<template>
  <div id="app">
    <header  v-if="isIE11 === false" id="header">
      <div class="left">
        <MusicPlayer/>
      </div>
      <div class="right">
        <div @click="showShareButtons = !showShareButtons" class="header-button">
          <span>
            <svg width="15px" height="17px" viewBox="0 0 15 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Share-Button" transform="translate(-8.000000, -10.000000)" stroke="#FFFFFF">
                        <path d="M13.3540839,16.822958 L17,15 L13.3540839,16.822958 C13.7555,17.2664768 14,17.8546854 14,18.5 C14,19.8807119 12.8807119,21 11.5,21 C10.1192881,21 9,19.8807119 9,18.5 C9,17.1192881 10.1192881,16 11.5,16 C12.2353972,16 12.8966322,16.3175263 13.3540839,16.822958 Z M17.6459161,21.822958 L14,20 L17.6459161,21.822958 C18.1033678,21.3175263 18.7646028,21 19.5,21 C20.8807119,21 22,22.1192881 22,23.5 C22,24.8807119 20.8807119,26 19.5,26 C18.1192881,26 17,24.8807119 17,23.5 C17,22.8546854 17.2445,22.2664768 17.6459161,21.822958 Z M19.5,16 C18.1192881,16 17,14.8807119 17,13.5 C17,12.1192881 18.1192881,11 19.5,11 C20.8807119,11 22,12.1192881 22,13.5 C22,14.8807119 20.8807119,16 19.5,16 Z" id="share-icon"></path>
                    </g>
                </g>
            </svg>
          </span>
          <span class="translation" v-translate>Share</span>
          <transition name="slide-fade">
            <ul v-if="showShareButtons === true" class="social-icons header-social">
              <li><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + windowLink" onclick="window.open(this.href,'targetWindow','toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250'); return false;"  target="_blank"><span><font-awesome-icon :icon="['fab', 'facebook-f']" /></span></a></li>
              <li><a onclick="window.open(this.href,'targetWindow','toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250'); return false;" :href="'https://twitter.com/share?text=Which Celine Are You?&hashtags=WhichCelineAreYou&url=' + windowLink"  target="_blank">
                <span><font-awesome-icon :icon="['fab', 'twitter']" />
                </span></a>
              </li>
              <li><a @click="copyLink()"><span><font-awesome-icon :icon="['fa', 'link']" /></span></a></li>
            </ul>
          </transition>
        </div>
        <a href="https://smarturl.it/CelineDionCourage" class="header-button" target="_blank" alt="Listen / Buy the new album">
          <span v-translate class="listen-buy">Listen</span>
        </a>
      </div>
      <div class="flag-choice"
        v-if="$route.name === 'home' || $route.name === '404'"
      >
        <ul>
          <li @click="changeLang('english')" class="english">EN</li>
          <li @click="changeLang('french')"  class="french">FR</li>
        </ul>
      </div>
    </header>

    <transition mode="out-in" name="fade">
      <router-view  v-if="isIE11 === false" />
    </transition>

    <footer v-if="isIE11 === false" id="footer">
      <div class="left">
        <span>2019 &copy; Sony Music Entertainment. All rights reserved. </span>
        <a target="_blank" href="https://www.sonymusic.com/feedback/"><span v-translate>Send us feedback</span></a>
        <a target="_blank" :href="ppLink"><span v-translate>Privacy policy</span></a>
        <a target="_blank" class="terms" :href="tcLink"><span v-translate>Terms and conditions</span></a>
        <a target="_blank" class="whymm" href="https://whymusicmatters.com/">whymusicmatters.com</a>
      </div>
      <div class="right">
        <ul class="social-icons">
          <li><a href="https://instagram.com/celinedion" target="_blank"><span><font-awesome-icon :icon="['fab', 'instagram']" /></span></a></li>
          <li><a href="https://facebook.com/celinedion"  target="_blank"><span><font-awesome-icon :icon="['fab', 'facebook-f']" /></span></a></li>
          <li><a href="https://twitter.com/celinedion"   target="_blank"><span><font-awesome-icon :icon="['fab', 'twitter']" /></span></a></li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import MusicPlayer from '@/components/MusicPlayer.vue';

export default {
  name: 'app',
  components: {
    MusicPlayer
  },
  data: function(){
    return {
      showShareButtons: false,
      isIE11: false,
      pointOfSaleLink: 'https://CelineDion.lnk.to/CourageUSAlbumDeluxe',
      windowLink: '',
      currentLang: window.lang,
      ppLink: 'https://www.sonymusic.com/privacy-policy/',
      tcLink: 'https://www.sonymusic.com/terms-and-conditions/',
    }
  },
  mounted(){
    if(localStorage.getItem('lang') != null){
      this.$translate.setLang(localStorage.getItem('lang'));
    }else{
      this.$translate.setLang('french');
    }

    this.windowLink = 'https://www.whichcelineareyou.celinedion.com';

    document.addEventListener('authed', function (e) {
      this.pointOfSaleLink = 'https://open.spotify.com/album/0mqNgHFh1NYaxmlMS5IeGc';
    });


    EventBus.$on('connected', (type) => {
      if(window.userType != 'Apple'){
        this.pointOfSaleLink = 'https://open.spotify.com/album/0mqNgHFh1NYaxmlMS5IeGc';
      }else{
        this.pointOfSaleLink = 'https://music.apple.com/us/album/courage-deluxe-edition/1480315784';
      }
    });

    if(/msie/.test(navigator.userAgent.toLowerCase())){
      this.isIE11 = true;
    }
  },
  methods: {
    changeLang: function(lang){

      window.lang = lang;
      localStorage.setItem('lang', lang)
      this.$translate.setLang(lang);
      if (lang === 'french'){
        this.ppLink = 'https://www.sonymusic.ca/fr/politique-de-confidentialite';
        this.tcLink = 'https://www.sonymusic.ca/fr/conditions-generales';
      } else {
        this.ppLink = 'https://www.sonymusic.com/privacy-policy/';
        this.tcLink = 'https://www.sonymusic.com/terms-and-conditions/';
      }
    },

    copyLink: function(){
      var aux = document.createElement("input");
      aux.setAttribute("value", this.windowLink);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
    }

  },
  locales: {
    english: {
       'WHICH': 'Which',
       'CELINE DION': 'Celine Dion',
       'ARE YOU?': 'are you?',
       'Choose a photo': 'Choose a photo',
       'Where would you rather be on a Friday night?': 'Where would you rather be on a Friday night?',
       'My couch in pjs - cuddled up with my dog': 'My couch in pjs, cuddled up with my dog',
       'At the club, flying on my own': 'At the club, flying on my own',
       'Wherever my friends are': 'Wherever my friends are',
       'A nice restaurant with my boo': 'A nice restaurant with my boo ',
       'In my room, writing in my diary': ' In my room, writing in my diary',
       'You’re at an amusement park. You…': 'You’re at an amusement park. You…',
       'Head straight to the highest ride': 'Head straight to the highest ride',
       'Win a prize for that special someone': 'Win a prize for that special someone',
       'Get chicken tenders with the squad': 'Get chicken tenders with the squad',
       'Get my face painted': 'Get your face painted',
       'I don’t go to amusement parks - too many germs': 'Don’t go to amusement parks - too many germs',
       'What is your ideal vacation?': 'What is your ideal vacation?',
       'City': 'City',
       'Beach': 'Beach',
       'Safari': 'Safari',
       'Jungle Cabana': 'Jungle Cabana',
       'Silent Retreat':  'Silent Retreat',
       'What city would you like to live in?': 'What city would you like to live in?',
       'Paris': 'Paris',
       'Milan': 'Milan',
       'Berlin': 'Berlin',
       'Montreal': 'Montreal',
       'New York': 'New York',
       'Pick one of these movies to watch': 'Pick one of these movies to watch',
       'Beauty and the Beast': 'Beauty and the Beast',
       'Stuart Little': 'Stuart Little',
       'Deadpool 2': 'Deadpool 2',
       'Up Close and Personal': 'Up Close and Personal',
       'Sleepless in Seattle': 'Sleepless in Seattle',
       'You are Fierce Celine!': 'You are Fierce Celine!',
       'You are bold, fearless, and an inspiration to others. Turn it up and keep living free.': 'You are bold, fearless, and an inspiration to others. Turn it up and keep living free.',
       'You are Life of the Party Celine!': 'You are Life of the Party Celine!',
       'You’re wild… in the best way. Now hit your playlist for some dance floor inspiration.': 'You’re wild… in the best way. Now hit your playlist for some dance floor inspiration.',
       'Ooh La La Celine!':'Ooh Là Là Celine!',
       'You own a candelabra, well, at least some candles. Now turn the lights down and let the power of love take over.': 'You own a candelabra, well, at least some candles. Now turn the lights down and let the power of love take over.',
       'You are Bestie Celine!': 'You are Bestie Celine!',
       'You are Ooh La La Celine!': 'You are Ooh Là Là Celine!',
       'You’re a rock and a shoulder to cry on. Like these songs, you make life easier. ': 'You’re a rock and a shoulder to cry on. Like these songs, you make life easier.',
       'You are All The Feels Celine!': 'You are All The Feels Celine!',
       'You are sensitive but strong. Just like Celine you have the courage to love fully. Let those feelings flow.': 'You are sensitive but strong. Just like Celine you have the courage to love fully. Let those feelings flow.',
       'GET THE NEW ALBUM': 'GET THE NEW ALBUM',
       'YOUR PLAYLIST HAS BEEN ADDED TO SPOTIFY': 'YOUR PLAYLIST HAS BEEN ADDED TO SPOTIFY',
       'Share your playlist': 'Share your playlist',
       'DISCOVER THE OTHER PLAYLISTS ': 'DISCOVER THE OTHER PLAYLISTS',
       'By connecting you agree to share your information with Sony Music Entertainment and receive updates from Célion Dion.': 'By connecting you agree to share your information with Sony Music Entertainment and receive updates from Céline Dion.',
       'Share your Celine': 'Share your Celine',
       'Download for Instagram': 'Download for Instagram',
       'Listen': 'Listen',
       'Buy': 'Buy',
       'Listen / Buy': 'Listen / Buy',
       'Connect to spotify or apple music to take our quiz and find out!': 'Connect to spotify or apple music to take our quiz and find out!',
       'Get your personalised playlist then listen and order the new album courage.': 'Get your personalised playlist then listen and order the new album courage.',
       'Share': 'Share',
       'Discover your inner Celine': 'Discover your inner Celine',
       'Take the quiz': 'Take The Quiz',
       'Use library': 'Use library',
       'Fierce': 'Fierce',
       'Bestie': 'Bestie',
       'All The Feels': 'All The Feels',
       'Ooh La La': 'Ooh Là Là',
       'Life Of The Party': 'Life Of The Party',
       'Take the quiz to get a personalized playlist including tracks from Celine’s new album, Courage': 'Take the quiz to get a personalized playlist including tracks from Celine’s new album, Courage',
       'Take the quiz again': 'Take the quiz again',
       'LISTEN NOW': 'LISTEN NOW',
       'Download For Story': "Download For Story",
       'Download For Post': 'Download For Post',
       'Send us feedback': 'Send us feedback',
       'Privacy policy': 'Privacy policy',
       'Terms and conditions': 'Terms and conditions',
       'Why music matters': 'Why music matters',
       'Connect to Spotify' : 'Connect to Spotify',
       'Listen to Courage now': 'Listen to Courage now',

       'Subscribe to the Celine Dion newsletter. I understand that by checking this box and clicking CONNECT TO SPOTIFY, I agree to receive electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates relating to Celine Dion.': 'Subscribe to the Celine Dion newsletter. I understand that by checking this box and clicking CONNECT TO SPOTIFY, I agree to receive electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates relating to Celine Dion.',
       'You may withdraw your consent to receive further electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates at any time by using the unsubscribe link included in any such message.': 'You may withdraw your consent to receive further electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates at any time by using the unsubscribe link included in any such message.'
       },
       french: {
       'WHICH': 'Quelle',
       'CELINE DION': 'Céline Dion',
       'ARE YOU?': 'es-tu ?',
       'Choose a photo': 'Choisis une photo',
       'Where would you rather be on a Friday night?': 'À quel endroit peut-on te retrouver un vendredi soir ?',
       'My couch in pjs - cuddled up with my dog': 'Sur mon divan, en pyjama, en train de câliner mon chien',
       'At the club, flying on my own': 'Dans le club, volant de mes propres ailes',
       'Wherever my friends are': 'Je suis là, peu importe où sont mes amis',
       'A nice restaurant with my boo': 'Dans un bon restaurant en compagnie de mon amour',
       'In my room, writing in my diary': 'Dans ma chambre, en train d’écrire dans mon journal intime',
       'You’re at an amusement park. You…': 'Dans un parc d’attractions, tu…',
       'Head straight to the highest ride': 'Te diriges directement au manège le plus vertigineux !',
       'Win a prize for that special someone': 'Tentes de gagner un prix pour une personne chère à tes yeux !',
       'Get chicken tenders with the squad': 'Rassembles tes amis pour aller manger de la barbe à papa !',
       'Get my face painted': 'Te fais maquiller le visage !',
       'I don’t go to amusement parks - too many germs': 'N’y es simplement pas – il y a beaucoup trop de germes dans les parcs d’attractions !',
       'What is your ideal vacation?': 'Quelles sont tes vacances de rêve ?',
       'City': 'En ville',
       'Beach': 'À la plage',
       'Safari':'Un safari',
       'Jungle Cabana': 'Une cabane dans la jungle',
       'Silent Retreat': 'Une retraite silencieuse',
       'What city would you like to live in?': 'Dans quelle ville rêves-tu d’habiter ?',
       'Paris': 'Paris',
       'Milan': 'Milan',
       'Berlin': 'Berlin',
       'Montreal': 'Montréal',
       'New York': 'New York',
       'Pick one of these movies to watch': 'Tu veux regarder un film, lequel choisis-tu ?',
       'Beauty and the Beast': 'La Belle et la Bête',
       'Stuart Little': 'Petit Stuart',
       'Deadpool 2': 'Deadpool 2',
       'Up Close and Personal': 'Intime et personnel',
       'Sleepless in Seattle': 'Nuits blanches à Seattle',
       'You are Fierce Celine!': 'Tu es la Céline audacieuse !',
       'You are bold, fearless, and an inspiration to others. Turn it up and keep living free.': 'Tu es audacieux/audacieuse, sans peur et tu es une inspiration pour les autres. Monte le volume et continue à profiter de la vie au max !',
       'You are Life of the Party Celine!': 'Tu es la Céline qui aime faire la fête !',
       'You’re wild… in the best way. Now hit your playlist for some dance floor inspiration.': 'Tu es extravagant / extravagante… mais dans le bon sens du terme ! Maintenant monte le son et prépare-toi à danser !',
       'You are Ooh La La Celine!': 'Tu es la Céline très Ouh là là !',
       'You own a candelabra, well, at least some candles. Now turn the lights down and let the power of love take over.': 'Tu possèdes certainement un grand chandelier… du moins quelques chandelles. Maintenant tamise les lumières et laisse-toi emporter par le pouvoir de l’amour.',
       'You are Bestie Celine!': 'Tu es la Céline BFF !',
       'You’re a rock and a shoulder to cry on. Like these songs, you make life easier. ': 'Tes proches peuvent toujours compter sur toi et ton écoute. Comme ces chansons, tu rends la vie plus douce.',
       'You are All The Feels Celine!': 'Tu es la Céline toute en émotions !',
       'You are sensitive but strong. Just like Celine you have the courage to love fully. Let those feelings flow.': 'Tu es sensible et fort/forte à la fois. Tout comme Céline, tu as le courage de vivre l’amour pleinement. Laisse-toi porter par toutes ces émotions.',
       'GET THE NEW ALBUM': 'OBTENEZ LE NOUVEL ALBUM',
       'YOUR PLAYLIST HAS BEEN ADDED TO SPOTIFY': 'VOTRE LISTE DE LECTURE A ÉTÉ AJOUTÉE À SPOTIFY',
       'Share your playlist': 'Partage ta liste de lecture',
       'DISCOVER THE OTHER PLAYLISTS': 'DÉCOUVREZ LES AUTRES LISTES DE LECTURE',
       'By connecting you agree to share your information with Sony Music Entertainment and receive updates from Célion Dion.': 'En vous connectant, vous acceptez de partager vos informations avec Sony Music Entertainment et de recevoir des mises à jour de Céline Dion.',
       'Share your Celine': 'Partage ton résultat',
       'Download for Instagram': 'Partage ton résultat sur Instagram',
       'Listen': 'Écouter dès maintenant',
       'Buy': 'Acheter',
       'Listen / Buy': 'Écouter / Acheter',
       'Connect to spotify or apple music to take our quiz and find out!': 'CONNECTE-TOI À SPOTIFY OU APPLE MUSIC POUR RÉPONDRE AU QUIZ ET LE DÉCOUVRIR !',
       'Get your personalised playlist then listen and order the new album courage.': 'OBTIENS TA LISTE DE LECTURE PERSONNALISÉE, ÉCOUTE ET COMMANDE LE NOUVEL ALBUM COURAGE.',
       'Share': 'Partager',
       'Discover your inner Celine': 'Découvre la Céline en toi',
       'Take the quiz': 'Répondre au quiz',
       'Use library': 'Utiliser mon historique d’écoute',
       'Fierce': 'Céline audacieuse',
       'Bestie': 'Céline BFF',
       'Life Of The Party': 'Céline qui aime faire la fête !',
       'All The Feels': 'Céline toute en émotions',
       'Ooh La La': 'Céline Ouh là là',
       'Take the quiz to get a personalized playlist including tracks from Celine’s new album, Courage': 'Réponds au quiz pour obtenir une liste de lecture personnalisée comprenant des chansons du nouvel album de Céline, Courage',
       'Take the quiz again': 'Recommence le quiz',
       'LISTEN NOW': 'Écouter dès maintenant',
       'Download For Story': "Télécharger au format vertical",
       'Download For Post': 'Télécharger au format carré ',
       'Send us feedback': 'Envoyez-nous vos commentaires',
       'Privacy policy': 'Politique de confidentialité',
       'Terms and conditions': 'Conditions d’utilisation',
       'Connect to Spotify': 'Connecte-toi à Spotify',
       'Listen to Courage now': 'Écouter Courage dès maintenant',
        'Subscribe to the Celine Dion newsletter. I understand that by checking this box and clicking CONNECT TO SPOTIFY, I agree to receive electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates relating to Celine Dion.': 'S’abonner à l’infolettre de Céline Dion. En cochant cette option ainsi que l’option « Se connecter à Spotify », j’accepte de recevoir des messages électroniques de la part de Sony Music Entertainment, Sony Music Canada Inc. et ses affiliés liés à Céline Dion.',
        'You may withdraw your consent to receive further electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates at any time by using the unsubscribe link included in any such message.': 'Vous pouvez vous désabonner en tout temps de la liste d’envoi de Sony Music Entertainment, Sony Music Canada Inc. et ses affiliés, en cliquant sur le lien de désinscription inclut dans chaque envoi.'
       }
   }
}
</script>

<style lang="scss">
html {
  background: #181818;
}
*, body {
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
}

* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input,
textarea,
button,
select,
div,
a {
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-thumb {
  background: #ddd;
}

*::-webkit-scrollbar-track {
  background: #666;
}

body {
  background: #181818;
}

a:active,
a:focus {
  outline: none !important;
}

input { -webkit-user-select:text;}

@font-face {
  font-family: 'fontello';
  src: url('/data/font/fontello.eot?8015460');
  src: url('/data/font/fontello.eot?8015460#iefix') format('embedded-opentype'),
       url('/data/font/fontello.woff?8015460') format('woff'),
       url('/data/font/fontello.ttf?8015460') format('truetype'),
       url('/data/font/fontello.svg?8015460#fontello') format('svg');
  font-weight: normal;
  font-style: normal;
}

// Global transition for Fade's
.fade-enter-active {
  transition: all .5s ease;
  transition-delay: 0.6s;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transition: all 0.4s;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
  transition-delay: 0.6s;
}
.slide-fade-leave-active {
  transition: opacity .5s, transform .6s;
  transition-delay: transform .2s;
  pointer-events: none;
  //transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100%);
  opacity: 0;
  pointer-events: none;
  @media screen and (max-width: 900px){
    transform: none;
  }
}
.slide-fade {
  opacity: 1;
  pointer-events: all;
  transform: none;
}


body {
  overflow: hidden;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}

header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 20px 40px;
  z-index: 10;
  background: none;
  z-index: 5;

  @media screen and (max-width: 900px){
    padding: 10px;
  }

  .flag-choice {
    float: right;
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      li {
        display: inline-block;
        margin: 7px 10px;
        padding: 0;
        height: 23px;
        line-height: 23px;
        font-size: 12px;
        text-align: center;
        width: auto;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
        opacity: 0.8;
        border-radius: 3px;
        overflow: hidden;
        transition: opacity 0.3s;

        //&.english {
        //  background-image: url('/data/images/usa-flag.png');
        //}
        //&.french {
        //  background-image: url('/data/images/french-canadian-flag.png?1');
        //}

        @media screen and (max-width: 900px){
          margin-top: 7px;
        }

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .left {
    float: left;
    min-width: 300px;

    @media screen and (max-width: 800px){
      min-width: 0px;
      max-width: 152px;
      overflow: hidden;
    }

    .music-player {
      float: left;
      span:first-child{
        display: none;
      }
      .mute-icon-container {
        float: left;
        margin-right: 10px;
        span.mute-icon {
          display: block;
          width: 38px;
          height: 38px;
          padding-top: 7px;
          background: #1E1E1E;
          cursor:pointer;
          border: 1px solid #1e1e1e;
          transition: all 0.3s;
          &:hover{
            background: none;
            border-color: #fff;
          }

          @media screen and (max-width: 900px){
            width:  30px;
            height: 30px;
            padding-top: 4px;
            svg {
              width: 12px;
            }
          }
        }
      }

      .song-name {
        padding: none;
        margin: 0;
        line-height: 38px;
        color: #fff;
        font-weight: normal;
        cursor: default;
        font-size: 14px;
        display: inline-block;
        @media screen and (max-width: 800px){
          height: 30px;
          line-height: 30px;
          font-size: 12px;
        }
        @media screen and (max-width: 420px){
          display: none;
        }
      }

    }

  }
  .right {
    float: right;

    .header-button {
      position: relative;
      display: inline-block;
      margin-left: 10px;
      height: 36px;
      background: #1E1E1E;
      line-height: 36px;
      border: 1px solid #1E1E1E;
      padding: 0 20px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      text-decoration: none;
      transition: all 0.3s;
      @media screen and (max-width: 900px){
        font-size: 10px;
        padding: 0 10px;
        height: 30px;
        line-height: 32px;
      }
      a{
        color: #fff;
      }
      span {
        display: inline-block;
        position: absolute;
        left: 9px;
        width: 30px;
        top: 2px;
        @media screen and (max-width: 900px){
            left: 5px;
            width: 20px;
        }
        svg{
          height: auto;
          width: 14px;
          @media screen and (max-width: 900px){
            width: 12px;
          }
        }
        &.listen-buy {
          position: static;
          width: auto;
          display: inline-block;
        }
        &.translation {
          display: inline-block;
          position: static;
          margin: 0;
          width: auto;
          height: auto;
          line-height: normal;
          top: 0;
          margin: 0;
          line-height: 12px;
        }
      }
      &:first-child{
        padding-left: 40px;
        position: relative;
        @media screen and (max-width: 900px){
          padding-left: 30px;
        }
      }

      &:hover {
        text-decoration: underline !important;
        span {
          text-decoration: underline !important;
        }
      }
    }

    ul {
      top: 20px;
      left: 50%;
      margin-left: -50px;
      width: 100px;
      position: absolute;
      padding: 0;
      background: #1E1E1E;
      color: #fff;
      display: inline-block;
      li {
        display: inline-block;
        margin: 0 0 0 15px;
        line-height: 35px;
        height: 35px;
        opacity: 0.8;
        font-size: 16px;
        color: #fff;
        transition: all 0.2s;
        svg {
          width: 20px;
          height: auto;
          color: #fff !important;
        }
        a {
          margin: 0;
          color: #fff;
          font-size: 18px;
        }
        &:first-of-type {
          svg {
            width: 9px;
          }
        }
        &:last-of-type {
          margin-right: 0;
        }
        &:hover {
          background-color: #313131;
          transition: opacity 0.3s;
          opacity: 1;
        }
      }
    }
  }
}

.body-container {
  position: relative;
  z-index: 1;
}

footer {
  width: 100%;
  line-height: 36px;
  align-self: flex-end;
  height: 36px;
  background: #181818;
  color: #fff;
  border-top: 1px solid #f1f1f1;
  font-size: 12px;
  padding: 0 15px;
  z-index: 10;

  .left {
    float: left;
    span {
      padding-right: 7px;
      margin: 0;
      opacity: 0.8;
      border-right: 1px solid #fff;
    }
    a span {
      border-right: none;
      padding: 0;
      margin: 0;
    }
    a {
      border-right: 1px solid #fff;
      padding: 0 14px;
      opacity: 0.8;
      transition: all 0.3s;

      &:hover {
        opacity: 1;
        color: #fff;
        transition: all 0.2s;
      }
    }
    @media screen and (max-width: 800px){
      a.terms,
      a.whymm,{
        display: block;
        width: 100%;
        text-align: center;
      }
    }
  }
  .right {
    float: right;
    a {
      float: left;
      display: inline-block;
      margin-right: 10px;
    }
    ul {
      float: right;
      padding: 0;
      margin: 0;
      display: inline-block;
      li {
        display: inline-block;
        margin: 0 15px 0 0 ;
        line-height: 35px;
        height: 35px;
        opacity: 0.8;
        font-size: 16px;
        transition: opacity 0.2s;
        a {
          margin: 0;
        }
        &:last-of-type {
          margin-right: 0;
        }
        &:hover {
          transition: opacity 0.3s;
          opacity: 1;
        }
      }
    }
  }

  a {
    text-decoration: none;
    color: #fff;
  }
}

@media screen and (max-width: 1100px){
  body {
    overflow-y: scroll;
    footer {
      padding: 10px 0 0 0;
      height: auto;
      .left {
        width: 100%;
        font-size: 12px;
        line-height: 22px;
        span {
          margin: 0;
          display: inline-block;
          padding: 0;
          border: none;
          font-size: 10px;
        }
        a {
          display: inline-block;
          font-size: 10px;
          padding: 0 6px;
          border: none;
        }
      }
      .right {
        display: block;
        width: 100%;
        text-align: center;
        a {
          float: none;
          display: inline-block;
        }
        ul.social-icons {
          display: inline-block;
          float: none;
        }
      }
    }
  }
}

@media screen and (max-width: 900px){
  body {
    #app {
     min-height: 100vh;
     height: auto;

     footer .left {
       span {
         width: 100%;
         display: block;
       }
       a {
         display: block;
       }
      }
    }
  }
}


.demo-icon,
.fontello-icon {
  font-family: 'fontello';
}

header .right .social-icons {
  top: 40px;
  li {
    display: inline-block;
    margin: 0;
    text-align: center;
    width: 33.3%;
    position: relative;
    span {
      border: none;
      position: static;
    }
  }

  &:after {
    bottom: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #1e1e1e;
    border-width: 10px;
    left: 50%;
    margin-left: -10px;
  }
}

// Outdated browser
.outdated-browser {
  display: block;
  height: 100%;
  padding: 40px;
  text-align: center;
  background: none;
  color: #000;

  div {
    margin: 50% auto 0 auto;
    width: 100%;
    display: block;

    p {
      font-size: 13px;
      line-height: 26px;
      margin: 0 0 20px 0;
    }
  }
}
</style>
